import React, { useState } from "react";
import Icon from "../../../../../../components/MainApp/atoms/Icon/icon";
import InputText from "../../../../../../components/MainApp/atoms/Forms/MainInput";
import ItemTags from "components/MainApp/organisms/OrdersV3/Item-Tags";
import DeviceSelector from "components/Functionals/DeviceSelector";

import styles from "./PrepOrders.OrderDetail.LoadMovementItems.module.scss";
import i18n from "i18n";
import TagReadInput from "shared/components/Input/TagReadInput";

export const LoadMovementItems = ({
  enabledRead,
  typeRead,
  refRead,
  receiveEvent,
  originalItems = [],
  selectedItems = [],
  total,
  handleSearch,
  handleDelete,
  handleDeleteAll,
  handleSend,
  handleReject,
  goBack,
}) => {
  const [searchedValue, setsearchedValue] = useState("");

  const searchValue = (e) => {
    setsearchedValue(e.target.value.trim());
  };

  const handleSubmit = function (e) {
    e.preventDefault();
    handleSearch(searchedValue);
    setsearchedValue("");
  };

  return (
    <div className={styles["load-movement-items-outter"]}>
      <div className={styles["load-movement-items-wrapper"]}>
        <div className={styles["load-movement-items-title-wrapper"]} onClick={goBack}>
          <div className={styles["load-movement-items-title-icon"]}>
            {" "}
            <Icon name="chevron" width={14} height={14} fill={"#62D862"} />
          </div>
          <h1 className={styles["load-movement-items-title"]}>{i18n.t("order.assembly")}</h1>
        </div>
        <div className={styles["device-selector-wrapper"]}>

          <DeviceSelector
            enabled={enabledRead}
            typeRead={typeRead}
            refRead={refRead}
            receiveEvent={receiveEvent}
            includeType={"MOB_READER"}
          />
        </div>
        <div className={styles["load-movement-items-content"]}>
          <div className={styles["load-movement-items-input-wrapper"]}>
            <div className={styles["load-movement-tagreadinput-wrapper"]}>
              <TagReadInput searchValue={searchValue} searchedValue={searchedValue} handleSubmit={handleSubmit} />
            </div>
          </div>
          <div className={styles["load-movement-items-count"]}>
            {originalItems.length}/{total}
          </div>
          <div className={styles["load-movement-items-list"]}>
            {selectedItems.map((item) => {
              return (
                <ItemTags
                  key={item.sku}
                  item={item}
                  quantity={item.tags.length}
                  expected={item.expectedUnits}
                  handleDelete={handleDelete}
                />
              );
            })}
          </div>
          <div className={styles["load-movement-items-buttons-wrapper"]}>
            <div
              className={`${styles["load-movement-items-button"]} ${styles["load-movement-items-clean"]}`}
              onClick={handleDeleteAll}
            >
              {" "}
              {i18n.t("clean")}{" "}
            </div>
            <div
              className={`${styles["load-movement-items-button"]} ${styles["load-movement-items-send"]}`}
              onClick={handleSend}
            >
              {i18n.t("continue").toUpperCase()}
            </div>
            <div
              className={`${styles["load-movement-items-button"]} ${styles["load-movement-items-reject"]}`}
              onClick={handleReject}
            >
              {" "}
              {i18n.t("decline").toUpperCase()}{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadMovementItems;
